<template>
  <div class="options-col">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.options-col{
  height: 100%;
  width: 180px;
  background-color: #FCFCFC;
  border-right: #DADADA solid 1px;
}
</style>
